import React, {Component} from 'react';

//controller
import MemberControllerAPI from '../../controllers/API/MemberControllerAPI.js';
import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI.js';

//css
import styles from '../../static/css/pageStyleModules/memberInfoMode.module.scss';

import HeaderLayout from '../layouts/header/HeaderLayout.js';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent.js';
import PieChartComponent from '../components/PieChartComponent.js';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent.js';

export default class MemberInfoMode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            memberData:{},
            thanksData:{},
            dataListForPieChart:[],
            isThanksExist:false,
        }
    }

    componentWillMount = () => {
        //idをもとに、データをget
        MemberControllerAPI.show(this.props.memberId)
        .then((result) => {                        
            this.setState({memberData:result.data})            
        })
        .catch((error) => {
            console.log(error);     
        })
    }

    componentDidMount = () => {
        //10秒ぐらい待ったらユラユラしはじめるとかおもしろい。
        //何パターンかからランダムな動きを、クラス付け替えでやってみよう。

        //ありがとデータ取得
        //メンバーのありがとを取得してきて、数をしらべる
        ThanksControllerAPI.index( {member_id:this.props.memberId} )
        .then((result) => {
            
            if(result.data.allThanksNumber > 0){
                const thankspersent = result.data.thanksPercent;            

                const dataListForPieChart = [
                    {rate:thankspersent,color:'hsl(6,77%,62%)'},
                    {rate:(100 - thankspersent),color:'#666666'}
                ]            

                this.setState({
                    thanksData:result.data,
                    dataListForPieChart:dataListForPieChart,
                    isThanksExist:true,
                });
            }
                                  
        })
        .catch((error) => {
            console.log(error);     
        })
    }

    changeToEditMode = () => {
        this.props.changeWorkMode('memberEditAndAddMode');
        //ここで本来ならキャラクターのidを渡すのだろうが、
        //このモードに来ている時点で渡してあるはずなのでとりあえず移動だけでOK
    }

    render(){
        return (
            <div className={styles['memberInfoModeArea']}>
              <HeaderLayout 
              leftIcon={'arrowLeft'} rightIcon={'pencil'}
              onLeftButtonClick={() => this.props.changeWorkMode('memberListMode')}
              onRightButtonClick={this.changeToEditMode} />

              <div className={styles['memberInfoArea']}>
                <div className={styles['memberBasicInfoArea']}>
                  <div className={styles['faceAndNameArea']}>
                    <div className={styles['faceIcon']}>
                      <FaceIconBaseComponent 
                      head={this.state.memberData.head}
                      eyes={this.state.memberData.eyes}
                      eyeblows={this.state.memberData.eyeblows}
                      mouth={this.state.memberData.mouth}
                      fillColor={this.state.memberData.color} />
                    </div>
                    <h2>{this.state.memberData.name}</h2>
                  </div>
                  { this.state.memberData.memo !== ''
                  ? <div className={styles['memberMemoArea']}>
                      <p>{ this.state.memberData.memo }</p>
                    </div>
                  : null}
                </div>
                
                { this.state.isThanksExist &&
                    <div className={styles['thanksChartArea']}>
                      <h2>ありがとチェックデータ</h2>
                      <div className={styles['pieChart']}>
                        <PieChartComponent 
                        dataList={this.state.dataListForPieChart}
                        holeSizePercent={60}
                        />
                        <div className={styles['heartIconArea']}>
                          <div className={styles['heartIcon']}>
                            <SvgIconBaseComponent image="facedHeart" fillColor="hsl(6,77%,62%)" />
                          </div>
                          <div className={styles['heartShadow']} />
                        </div>
                      </div>

                      <div className={styles['dataDisplayArea']}>
                        <div className={styles['thanksPercentDisplay']}>
                          <span>{this.state.thanksData.thanksPercent}</span>
                          <span>パーセント</span>
                        </div>
                        <div className={styles['thanksNumberDisplay']}>
                          <div className={styles['thanksDisplayBox']}>
                            <div className={styles['heartIcon']}>
                              <SvgIconBaseComponent image="facedHeart" fillColor="hsl(6,77%,62%)" />
                            </div>
                            <div className={styles['thanksNumber']}>
                              {this.state.thanksData.checkedThanksNumber}
                            </div>
                          </div>
                          <div className={styles['thanksDisplayBox']}>
                            <div className={styles['heartIcon']}>
                              <SvgIconBaseComponent image="facedHeart" fillColor="#666666" />
                            </div>
                            <div className={styles['thanksNumber']}>
                              {this.state.thanksData.allThanksNumber - this.state.thanksData.checkedThanksNumber}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                }

              </div>
            </div>
        )
    }
}

//ここでありがと数、未ありがと数のデータなんか出すのもいいかも
//ありがと率とかも

//ありがと率、最近のありがととか。